import {
    trackGenericPromptOpen,
    trackGenericPromptClose,
    trackGenericPromptSignIn,
    trackGenericPromptRegister
} from './AuthPrompts.tracking';
import { Prompts } from './AuthPrompts.types';
import { consentNotShownInLastTenMins } from './utils/consentNotShownInLastTenMins';

export const GENERAL_PROMPT_EXPERIMENT =
    'crme_1088_lsrp_sign_in_general_prompt';

export const LDP_PROMPT_EXPERIMENT =
    'crme_1093_ldp_sign_in_save_listing_prompt';

export const PROMPTS: Prompts = {
    generic: {
        experimentName: GENERAL_PROMPT_EXPERIMENT,
        title: "Like what you see? You can save it when you're signed in",
        tracking: {
            trackOpen: trackGenericPromptOpen,
            trackClose: trackGenericPromptClose,
            trackSignIn: trackGenericPromptSignIn,
            trackRegister: trackGenericPromptRegister
        },
        condition: (
            isMobile: boolean,
            isLoggedOut: boolean,
            consentCookie: string | undefined
        ) => {
            return (
                isMobile &&
                isLoggedOut &&
                consentNotShownInLastTenMins(consentCookie)
            );
        }
    },
    ldpSaveListing: {
        experimentName: LDP_PROMPT_EXPERIMENT,
        title: "Like what you see? You can save it when you're signed in",
        tracking: {
            trackOpen: trackGenericPromptOpen,
            trackClose: trackGenericPromptClose,
            trackSignIn: trackGenericPromptSignIn,
            trackRegister: trackGenericPromptRegister
        },
        condition: (
            isMobile: boolean,
            isLoggedOut: boolean,
            consentCookie: string | undefined
        ) => {
            return (
                isMobile &&
                isLoggedOut &&
                sessionStorage.getItem('authPromptClose') === null &&
                consentNotShownInLastTenMins(consentCookie)
            );
        },
        delayCondition: {
            prompt_launch: {
                time: 0
            },
            prompt_delayed: {
                time: 15
            }
        }
    }
};

export const PROMPT_EXPERIMENT_BREAKPOINT = 768;

export const CONSENT_COOKIE = 'cookie_consents';
